import axios from "axios";
import { headersProvider } from "../apiHelpers";
import constants from "../constants";

export const getPreSignedUrl = ({ fileName, parentId, field }) =>
  axios.post(
    `${constants.apiHost}/files/request-upload-url`,
    {
      fileName,
      parentId,
      field,
    },
    {
      headers: headersProvider(),
    },
  );

export const getReadPresignedUrl = ({ parent, parentId, hostedLink }) =>
  axios.get(`${constants.apiHost}/files/file-read`, {
    params: {
      parent,
      parentId,
      hostedLink,
    },
    headers: headersProvider(),
  });

export const getDownloadUrl = ({ hostedLink }) =>
  axios.get(`${constants.apiHost}/files/file-download`, {
    params: { hostedLink },
    headers: headersProvider(),
  });

// Get anonymous sharing link with expiration for AI services
// Currently only used for ms files
export const getAIAccessUrl = ({ parent, parentId, hostedLink }) =>
  axios.get(`${constants.apiHost}/files/ai-access-url`, {
    params: {
      parent,
      parentId,
      hostedLink,
    },
    headers: headersProvider(),
  });

export const attachFileToParent = ({
  parent,
  parentId,
  fileName,
  extension,
  mimeType,
  hostedLink,
  field,
}) =>
  axios.post(
    `${constants.apiHost}/files/attach-file`,
    {
      parent,
      parentId,
      fileName,
      extension,
      mimeType,
      hostedLink,
      field,
    },
    {
      headers: headersProvider(),
    },
  );

export const deleteFileApi = ({ fileId }) =>
  axios.post(
    `${constants.apiHost}/files/delete-file`,
    {
      fileId,
    },
    {
      headers: headersProvider(),
    },
  );

export const getParentFiles = ({ parent, parentId }) =>
  axios.get(`${constants.apiHost}/files/get-parent-files`, {
    headers: headersProvider(),
    noTrailingSlash: true,
    params: {
      parentId,
      parent,
    },
  });

export const searchApi = ({ searchInput }) =>
  axios.post(
    `${constants.apiHost}/dashboard/search`,
    {
      searchInput,
    },
    {
      headers: headersProvider(),
    },
  );

export const getBuIdByName = ({ buName }) =>
  axios.post(
    `${constants.masterApi}/base-backend/user/bu_id`,
    {
      bu_name: buName,
    },
    {
      headers: headersProvider(),
    },
  );

export const downloadFileProxy = ({ url }) =>
  axios.get(`${constants.apiHost}/agreements/download-proxy`, {
    params: { url },
    responseType: "arraybuffer",
    headers: headersProvider(),
  });

export const downloadViaProxy = async (url) => {
  const response = await axios.get(
    `${constants.apiHost}/agreements/download-proxy`,
    {
      params: { url },
      responseType: "arraybuffer",
      headers: headersProvider(),
    },
  );
  return {
    data: response.data,
    contentType: response.headers["content-type"] || "application/octet-stream",
  };
};
